export const CREATE_FIERBASE = 'CREATE_CONFIG';
